import FilterDrawer from 'components/Assignments/FilterDrawer';
import ImportQuizDialog from 'components/Quizzes/ImportQuizDialog';
import { useApp } from 'contexts/app';
import { useViewport } from 'contexts/viewport';
import Desktop from 'pages/Quizzes/desktop';
import Mobile from 'pages/Quizzes/mobile';
import { PageContext } from 'pages/Quizzes/PageProvider';
import Tablet from 'pages/Quizzes/tablet';
import { useContext } from 'react';
import { Loading } from 'shell/components';

const PageLayout = () => {
    const { isLoading } = useApp();
    const { device } = useViewport();
    const { filters, setFilters, resetFilters } = useContext(PageContext);

    if (isLoading) return <Loading />;

    return (
        <>
            {{ mobile: <Mobile />, tablet: <Tablet />, desktop: <Desktop /> }[device]}
            <FilterDrawer filters={filters} setFilters={setFilters} resetFilters={resetFilters} />
            <ImportQuizDialog />
        </>
    );
};

export default PageLayout;
